import { Checkbox } from "@mui/material";
import { iDataUserSuborg } from "../../../interfaces/SuperAdmin/Pages/iDataUserSuborg";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../ui-components/StyledTables";

interface Props {
  usuario: iDataUserSuborg;
  i: number;
  isSelected: boolean;
  handleSelect: (id: string) => void;
}

export const RowUserSuborg: React.FC<Props> = ({
  usuario,
  i,
  isSelected,
  handleSelect,
}) => {
  const { nombres, apellidos, estado, email } = usuario;

  return (
    <StyledTableRow>
      <StyledTableCell>
        <Checkbox
          color="primary"
          checked={isSelected}
          onChange={() => handleSelect(usuario.id_usuario)}
        />
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>{i}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {nombres}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {apellidos}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {email}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {estado}
      </StyledTableCell>
    </StyledTableRow>
  );
};
